import WaitingListExpiredTable from './WaitingListExpiredTable.component';

export default WaitingListExpiredTable;
